import { Instance } from 'mobx-state-tree'
import { TournamentScheduleModelBase } from './TournamentScheduleModel.base'

/* The TypeScript type of an instance of TournamentScheduleModel */
export interface TournamentScheduleModelType extends Instance<typeof TournamentScheduleModel.Type> {}

/* A graphql query fragment builders for TournamentScheduleModel */
export {
  selectFromTournamentSchedule,
  tournamentScheduleModelPrimitives,
  TournamentScheduleModelSelector
} from './TournamentScheduleModel.base'

/**
 * TournamentScheduleModel
 */
export const TournamentScheduleModel = TournamentScheduleModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
